<template>
    <VUEModal v-if="PopupRemoveRighello"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)"
            Altezza="140px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in GraphData.ListaRighelli"
                    :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  
  <VUEModal v-if="PopupAddRighello"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)"
            Altezza="140px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupAddRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="font-weight:bold;width: 120px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="font-weight:bold;width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)"
            Altezza="150px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="GraphData.AxisY.Min" @blur="GraphData.AxisY.Min = ConvertiValoreInCentesimi(GraphData.AxisY.Min)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="GraphData.AxisY.Max" @blur="GraphData.AxisY.Max = ConvertiValoreInCentesimi(GraphData.AxisY.Max)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="GraphData.AxisY.Udm" @blur="GraphData.AxisY.Udm = ConvertiValoreInCentesimi(GraphData.AxisY.Udm)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupUdmX"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)"
            :Altezza="'80px'"
            :Larghezza="'500px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="GraphData.AxisX.UdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="GraphData.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()" />

  <div v-if="IsGraficoModulabile" style="height: 20px; width: 20px; background-color: grey; position: relative; top: 3px; left: 98%; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MenuImpostazioni = !MenuImpostazioni">
    <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>  
    <div v-if="MenuImpostazioni && IsGraficoModulabile" style="width: 20px; position: absolute; top: 25px; pointer-events: all">
      <div class="ZMGraficoGenericoBottoni" @click="OnClickAdatta">
        <a class="fa fa-arrows" :title="this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="OnClickUdmX">
        <a class="fa fa-sliders" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ApriPopupImpostazioniY">
        <a class="fa fa-sort-amount-asc" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <!-- <div class="ZMGraficoGenericoBottoni" @click="ApriPopupAddRighello">
        <a class="fa fa-pencil" :title="this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div> -->
      <!-- <div v-if="GraphData.ListaRighelli.length != 0" class="ZMGraficoGenericoBottoni" @click="ApriPopupRemoveRighello()">
        <a class="fa fa-times" :title="this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div> -->
      <div class="ZMGraficoGenericoBottoni" @click="EsportaComePDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
  </div> 
  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50" @mouseup="OnMouseUp"></canvas>
  </div>      
</template>

<script>
// import { TZGraphMarkup, TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
// import { TZGraph } from '@/utils/ZGraph.js'
import { SystemInformation, TIPI_UDM_X, TIPOLOGIA_GRAFICI_STORICI, COLORI_FALDE, SPESSORE_LINEE_GRAFICI, COLORI_SOGLIE_ALLARMI, SPESSORE_LINEE_SOGLIE_ALLARMI } from '@/SystemInformation'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEModal from '@/utils/VUEModal.vue'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
// import { TIPI_UDM_X, SOGLIE_GRAFICI_VELOCITA } from '@/SystemInformation'

export default 
{
  components: { VUEModal, VUEColorPicker },
  mixins: [ MixInsGestioneTraduzioni, MixInsGraficiStorici ],
  data() 
  {
    return {
              ObjGrafico             : null,
              TipiUdmX               : TIPI_UDM_X,
              TipiStorici            : TIPOLOGIA_GRAFICI_STORICI,
              SpessoreGrafico        : SPESSORE_LINEE_GRAFICI,
              SegmentoVelocita       : {},
              DisegnoInCorso         : false,
              PopupAddRighello       : false,
              ModificaAl             : false,
              PopupRemoveRighello    : false,
              PopupImpostazioniAsseY : false,
              PopupUdmX              : false,
              MenuImpostazioni       : false,
              PopupColorPicker       : false,
              ObjDati                : null,
              Stacking               : 10,
              RighelloToRemove       : '',
              IndiceSegmento         : 0,
              Grafici                : {},
              ColoriFalde            : COLORI_FALDE,
              ColoreInModifica       : { Colore: '#000000' },
              ObjNewRighello         : { Data: '', Ora : '', PrettyDateTime: '', Colore: '#000000' },
              LinguaUtente           : SystemInformation.UserInformation.Lingua,
              ColoriSoglieAllarmi    : COLORI_SOGLIE_ALLARMI,
              SpessoreLineeAllarmi   : SPESSORE_LINEE_SOGLIE_ALLARMI,
              PopupValoriAsseY       : {Min : 0, Max : 0, Udm : 0}
           }

  },
  props: [ 
            "WidthGrafico", 
            "HeightGrafico", 
            "Modulo", 
            "ObjDal", 
            "ObjAl", 
            "TipoGrafico", 
            "PropsGrafico", 
            "Repaint", 
            "GraficiChange", 
            "PressAdatta",
            "IsVelocita",
            "IsAccelerazione",
            "IsVelocitaGiornaliera",
            "IsAccelerazioneGiornaliera",
            "ListaFalde",
            "ListaFaldeChange",
            "ListaSegmenti",
            "OggettoTotaleSpostamento",
            "AbilitaDisegnaVelocita",
            "IsGraficoModulabile",
            "OggettoDati", 
            "DescrizioneSitoPDF",
            "AddDatiPDF",
            "CatenaInfo",
            "ListaModuli",
            "ColoreModulo",
            "SoglieAllarmi"
         ],
  methods:
  {
    Adatta(MaxAsseY, MinAsseY, UdmY, NewUdmX = null)
    {
      //Asse X
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + ' ' + (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + ' ' + (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)

      if(NewUdmX == null)
      { 
        const MS_GIORNALIERI = 24*60*60*1000;
        let Divisore = 24
        switch(this.TipoGrafico)
        {
          case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI)     : Divisore = 36; break
          case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SOVR)         : Divisore = 24; break
          case (this.TipiStorici.VELOCITA_MEDIA_ORARIA)            :
          case (this.TipiStorici.ACCELERAZIONE_MEDIA_ORARIA)       : Divisore = 36; break
          case (this.TipiStorici.VELOCITA_MEDIA_GIORNALIERA)       :
          case (this.TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA)  : this.ObjGrafico.DelayGiornalieroMS = (MS_GIORNALIERI / 2)
                                                                     Divisore = 8;
                                                                     break
        }

        this.ObjGrafico.AxisX.NotchDim      = TInfoGraphic.GetAdjustedNotchDim(Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min), Divisore)
        
        if(this.TipoGrafico == this.TipiStorici.VELOCITA_MEDIA_GIORNALIERA || this.TipoGrafico == this.TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA)
          this.ObjGrafico.AxisX.NotchDim = MS_GIORNALIERI
      
      }
      else this.ObjGrafico.AxisX.NotchDim = NewUdmX
      // this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim
      this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize = 13

      //Asse Y
      this.ObjGrafico.AxisY.Max           = MaxAsseY
      this.ObjGrafico.AxisY.Min           = MinAsseY
      this.ObjGrafico.AxisY.NotchDim      = UdmY
      this.ObjGrafico.AxisY.OffsetNotch   = Math.abs(MinAsseY) - TZMathFunct.GetMultiplo(Math.abs(MinAsseY), UdmY, 'Difetto')
      
      this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

      //Asse Y Right
      if(this.ListaFalde != undefined && this.ListaFalde.length != 0)
      {
        let ObjConsiderato = this.OggettoTotaleSpostamento != null ? this.OggettoTotaleSpostamento : this.Modulo
        this.ObjGrafico.ClearOtherAxes()
        this.ObjGrafico.TerzoAsse               = this.ObjGrafico.AddOtherAxis()
        this.ObjGrafico.TerzoAsse.FontSize      = 13;
        this.ObjGrafico.TerzoAsse.CenterLabel   = ' ' + this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_LV_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']       '
        this.ObjGrafico.TerzoAsse.NotchType     = TZGraphNotchType.notStandard
        this.ObjGrafico.TerzoAsse.Max           = ObjConsiderato.MaxAdattamentoAsseYPress
        this.ObjGrafico.TerzoAsse.Min           = ObjConsiderato.MinAdattamentoAsseYPress
        this.ObjGrafico.TerzoAsse.NotchDim      = ObjConsiderato.UdmYPress
        this.ObjGrafico.TerzoAsse.OffsetNotch   = 0
        this.ObjGrafico.TerzoAsse.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))
        this.ObjGrafico.TerzoAsse.NotchColor    = 'blue'
        this.ObjGrafico.TerzoAsse.NotchPenStyle = [0, 0]
        this.ObjGrafico.TerzoAsse.LabelOnGraph  = true
        this.ObjGrafico.TerzoAsse.NotchFontSize = 11
        this.ObjGrafico.TerzoAsse.Color         = 'blue'        
      }

      setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },

    ConvertiMillisecondiInData(Data)
    {
      let NewDate = new Date(Number(Data.toFixed()));
      NewDate.setSeconds(0, 0);
      return NewDate.getTime(); 
    },

    ConvertiDataInMillisecondi(Data)    
    {     
      let NewDate = new Date(Data)
      return NewDate.getTime()
    },

    ConvertiValoreInCentesimi(Valore)
    {
      let Numero = TZMathFunct.GetMultiplo(Valore, 0.01, 'Eccesso')
      
      return Number(Numero.toFixed(2))
    },

    OnMouseUp(event)
    {
      if(this.AbilitaDisegnaVelocita)
      {
        let TargetElemento = event.originalTarget || event.target
        let MouseX = event.x - this.ObjGrafico.__Margins.Left - TargetElemento.offsetLeft
        let RealUdmX = this.ObjGrafico.__GetXRealUdmFromPixels(MouseX)
        let RealDataIniziale = -1
        let RealDataFinale   = -1 
        
        if(this.OggettoTotaleSpostamento != null)
        {
          RealDataIniziale = this.ConvertiDataInMillisecondi(this.OggettoTotaleSpostamento.ListaTotaliSpostamento[0].Data)
          RealDataFinale   = this.ConvertiDataInMillisecondi(this.OggettoTotaleSpostamento.ListaTotaliSpostamento[(this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length -1)].Data)
        }

        if(this.Modulo != null)
        {
          RealDataIniziale = this.ConvertiDataInMillisecondi(this.Modulo.Dati[0].Data)
          RealDataFinale   = this.ConvertiDataInMillisecondi(this.Modulo.Dati[(this.Modulo.Dati.length -1)].Data)
        }
        
        if(RealUdmX > this.ObjGrafico.AxisX.Min && 
           RealUdmX < this.ObjGrafico.AxisX.Max &&
           RealUdmX >= RealDataIniziale &&
           RealUdmX <= RealDataFinale &&
           RealDataIniziale !== -1 &&
           RealDataFinale !== -1)
        {
          if(this.IndiceSegmento % 2 == 0)
          {
            this.SegmentoVelocita.Dal = this.ConvertiMillisecondiInData(RealUdmX)
            this.SegmentoVelocita.NomeSegmento = 'V' + (this.LsSegmenti.length + 1)
            this.IndiceSegmento++
            window.addEventListener('mousemove', this.GetMousePosition)
          }
          else
          {
            window.removeEventListener('mousemove', this.GetMousePosition)
            this.DisegnoInCorso = false
            this.SegmentoVelocita = {}
            this.IndiceSegmento++
          }          
        }
      }
    },

    GetMousePosition(event)
    {
      let TargetElemento = event.originalTarget || event.target
      let MouseX = event.x - this.ObjGrafico.__Margins.Left - TargetElemento.offsetLeft
      let RealUdmX = this.ObjGrafico.__GetXRealUdmFromPixels(MouseX)
      let RealDataIniziale = -1
      let RealDataFinale   = -1 
      
      if(this.OggettoTotaleSpostamento != null)
      {
        RealDataIniziale = this.ConvertiDataInMillisecondi(this.OggettoTotaleSpostamento.ListaTotaliSpostamento[0].Data)
        RealDataFinale   = this.ConvertiDataInMillisecondi(this.OggettoTotaleSpostamento.ListaTotaliSpostamento[(this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length -1)].Data)
      }

      if(this.Modulo != null)
      {
        RealDataIniziale = this.ConvertiDataInMillisecondi(this.Modulo.Dati[0].Data)
        RealDataFinale   = this.ConvertiDataInMillisecondi(this.Modulo.Dati[(this.Modulo.Dati.length -1)].Data)
      }
      
      if(event.target.localName === 'canvas' &&
         RealUdmX > this.ObjGrafico.AxisX.Min && 
         RealUdmX < this.ObjGrafico.AxisX.Max &&
         RealUdmX >= RealDataIniziale &&
         RealUdmX <= RealDataFinale &&
         RealDataIniziale !== -1 &&
         RealDataFinale !== -1)
      {
        this.SegmentoVelocita.Al = this.ConvertiMillisecondiInData(RealUdmX)
        if(!this.DisegnoInCorso)
        {
          if(this.SegmentoVelocita.Dal < this.SegmentoVelocita.Al)
          {
            this.LsSegmenti.push({Label: this.SegmentoVelocita.NomeSegmento, Dal : this.SegmentoVelocita.Dal, Al : this.SegmentoVelocita.Al, IsDisegnato : true})
            this.ModificaAl = true
          }
          else 
          {
            this.LsSegmenti.push({Label: this.SegmentoVelocita.NomeSegmento, Al : this.SegmentoVelocita.Dal, Dal : this.SegmentoVelocita.Al, IsDisegnato : true})
            this.ModificaAl = false
          }
          this.DisegnoInCorso = true
        }
        else
        {
          if(this.ModificaAl)
          {
            if(this.SegmentoVelocita.Dal < this.SegmentoVelocita.Al)
            {
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Al = this.SegmentoVelocita.Al
            }
            else
            {
              let DataTmp = this.LsSegmenti[(this.LsSegmenti.length - 1)].Dal
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Dal = this.LsSegmenti[(this.LsSegmenti.length - 1)].Al
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Al = DataTmp
              this.ModificaAl = false
            }
          }
          else
          {
            if(this.SegmentoVelocita.Dal > this.SegmentoVelocita.Al)
            {
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Dal = this.SegmentoVelocita.Al
            }
            else
            {
              let DataTmp = this.LsSegmenti[(this.LsSegmenti.length - 1)].Al
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Al = this.LsSegmenti[(this.LsSegmenti.length - 1)].Dal
              this.LsSegmenti[(this.LsSegmenti.length - 1)].Dal = DataTmp
              this.ModificaAl = true
            }
          } 
        }
      }
      this.Disegna()
    },

    GetMaxAxisY()
    {
      let Result = 0
      if(this.Modulo != undefined)
      {
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(Result < this.Modulo.Dati[i].Pitch)
            Result = this.Modulo.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Modulo != undefined)
      {
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(Result > this.Modulo.Dati[i].Pitch)
            Result = this.Modulo.Dati[i].Pitch
        }
      }
      return Result
    },

    CalcolaMillisecondi(UdmX, TipoUdmX)
    {
      let NewUdm = 0
      switch (TipoUdmX)
      {
        case TIPI_UDM_X.Giorni  : {
                                    NewUdm = UdmX * 86400000
                                    break
                                  }
        case TIPI_UDM_X.Ore     : {
                                    NewUdm = UdmX * 3600000
                                    break
                                  }
        case TIPI_UDM_X.Minuti  : {
                                    NewUdm = UdmX * 60000
                                    break
                                  }
        default                 : NewUdm = UdmX
      }
      this.ObjGrafico.AxisX.OffsetNotch = 0
      return NewUdm
    },

    Disegna()
    {
      let NewUdmX = null
      if (this.OggettoTotaleSpostamento != undefined && this.OggettoTotaleSpostamento.ModificatoAsseX)
        NewUdmX = this.CalcolaMillisecondi(this.OggettoTotaleSpostamento.AdattaUdmX, this.OggettoTotaleSpostamento.AdattaTipoUdmX)

      if (this.Modulo != undefined && this.Modulo.ModificatoAsseX)
        NewUdmX = this.CalcolaMillisecondi(this.Modulo.AdattaUdmX, this.Modulo.AdattaTipoUdmX)
 
      if(this.OggettoTotaleSpostamento != null)
      {
        this.Adatta(this.OggettoTotaleSpostamento.MaxAdattamentoAsseYSpost, this.OggettoTotaleSpostamento.MinAdattamentoAsseYSpost, this.OggettoTotaleSpostamento.UdmYSpost, NewUdmX)
      }
      else
      {
        if(this.IsVelocita || this.IsVelocitaGiornaliera)
          this.Adatta(this.Modulo.MaxAdattamentoAsseYVel, this.Modulo.MinAdattamentoAsseYVel, this.Modulo.UdmYVel, NewUdmX)
        else if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
          this.Adatta(this.Modulo.MaxAdattamentoAsseYAccel, this.Modulo.MinAdattamentoAsseYAccel, this.Modulo.UdmYAccel, NewUdmX)
        else this.Adatta(this.Modulo.MaxAdattamentoAsseYSpost, this.Modulo.MinAdattamentoAsseYSpost, this.Modulo.UdmYSpost, NewUdmX)
      }

      this.InserisciDati()

      setTimeout(() => { this.ObjGrafico.Paint()})
    },

    GetYSegmenti(XCoord, YCoord)
    {
      this.ListaSegmenti.forEach((element) => 
      {
        if (element.Dal == XCoord && element.IsDisegnato === undefined)
          element.YDal = YCoord
        if (element.Al == XCoord && element.IsDisegnato === undefined)
          element.YAl = YCoord
      })
    },

    OnClickAdatta()
    {
      this.MixInsOnClickAdattaSpostamenti(this.PropsGrafico, true)
    },

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXSpostamenti(this.PropsGrafico, true)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYSpostamenti(this.PropsGrafico, true)
    },

    AnnullaPopupImpostazioniY()
    {
      this.MixInsAnnullaPopupImpostazioniYSpostamenti(this.PropsGrafico)
    },

    GetUnitaDiMisuraAsseY()
    {
      this.MixInsGetUnitaDiMisuraAsseYSpostamenti()
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloSpostamenti(this.PropsGrafico, true)
    },

    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloSpostamenti()
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloSpostamenti(this.PropsGrafico, true)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    EsportaComePDF()
    {
      let ArrayModulo = []
      ArrayModulo.push(TZGenericFunct.GetCopyOfObject(this.Modulo))

      let ArrayOggettoGrafico = []
      ArrayOggettoGrafico.push(TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))
      
      if(ArrayOggettoGrafico.OtherAxis != undefined && ArrayOggettoGrafico.OtherAxis.length > 0)
      {
        ArrayOggettoGrafico.OtherAxis.forEach(AsseAlternativa => { AsseAlternativa.NotchFontSize = 17 });
      }

      this.MixInsEsportaComePDF(ArrayModulo, true, ArrayOggettoGrafico, this.Modulo.Id)

      // this.MixInsEsportaComePDF(this.Modulo, true, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))
    },

    InserisciDati()
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()
      
      if(this.OggettoTotaleSpostamento != null)
      {
        this.Grafici.Spostamento = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'navy', this.SpessoreGrafico, true, null, null, false)

        if(this.IsVelocitaGiornaliera || this.IsAccelerazioneGiornaliera)
          this.Grafici.Spostamento = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'green', this.SpessoreGrafico, true, null, null, false)

        for (let i = 0; i < this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length; i++)
        {
          let Dato   = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i]
          let XCoord = Date.parse(Dato.Data)

          this.GetYSegmenti(XCoord, Dato.SpostamentoTotale)
          this.Grafici.Spostamento.AddPoint(XCoord, Dato.SpostamentoTotale)
        }
        if (this.IsAccelerazione && this.IsAccelerazioneGiornaliera)
        {          
          this.Grafici.Spostamento.__Points[this.Grafici.Spostamento.__Points.length - 2].Y = 0
        }
      }
      else
      {
        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          let ListaDrawVelocita = []

          if(this.IsVelocita)
          {
            this.Grafici.Velocita = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'navy', this.SpessoreGrafico, true, null, null, false)
            ListaDrawVelocita     = this.DrawVelocita(false, true)
          }
          if(this.IsVelocitaGiornaliera)
          {
            this.Grafici.Velocita = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'green', this.SpessoreGrafico, true, null, null, false)
            // this.Grafici.Soglia1  = this.ObjGrafico.AddGroupPoint(1, 'blue', 1, this.PropsGrafico.SoglieDiAllarme ? true : false)
            // this.Grafici.Soglia2  = this.ObjGrafico.AddGroupPoint(1, 'yellow', 1, this.PropsGrafico.SoglieDiAllarme ? true : false)
            // this.Grafici.Soglia3  = this.ObjGrafico.AddGroupPoint(1, 'red', 1, this.PropsGrafico.SoglieDiAllarme ? true : false)

            ListaDrawVelocita     = this.DrawVelocita(true, true)
          }

          for (let i = 0; i < ListaDrawVelocita.length; i++)
          {
            let Dato   = ListaDrawVelocita[i]
            let XCoord = Dato.X
            this.Grafici.Velocita.AddPoint(XCoord, Dato.Y)              
          }
        }
        else
        {
          if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
          {
            let ListaDrawAccelerazione = []

            if(this.IsAccelerazione)
            {
              this.Grafici.Accelerazione = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'navy', this.SpessoreGrafico, true, null, null, false)
              ListaDrawAccelerazione = this.DrawAccelerazione(false, true)
            }
            if(this.IsAccelerazioneGiornaliera)
            {
              this.Grafici.Accelerazione = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'green', this.SpessoreGrafico, true, null, null, false)
              ListaDrawAccelerazione = this.DrawAccelerazione(true, true)
            }

            for (let i = 0; i < ListaDrawAccelerazione.length; i++)
            {
              let Dato   = ListaDrawAccelerazione[i]
              let XCoord = Dato.X
              this.Grafici.Accelerazione.AddPoint(XCoord, Dato.Y)
            }
          }
          else
          {
            this.Grafici.Spostamento  = this.ObjGrafico.AddGroupPoint(1, this.IsGraficoModulabile ? this.ColoreModulo : 'navy', this.SpessoreGrafico, true, null, null, false)

            for (let i = 0; i < this.Modulo.Dati.length; i++)
            {
              let Dato   = this.Modulo.Dati[i]
              if (Dato.Pitch != null && Dato.Roll != null)
              {
                let XCoord = Date.parse(Dato.Data)
                this.GetYSegmenti(XCoord, Dato.Spostamento)
                this.Grafici.Spostamento.AddPoint(XCoord, Dato.Spostamento)
              }              
            }
          }
        }
      }
      
      if(!this.IsVelocitaGiornaliera)
        this.ObjGrafico.ClearSegmenti()
      
      for (let i = 0; i < this.ListaSegmenti.length; i++)
      { 
        let Segmento = this.ListaSegmenti[i]
        let XStart = Segmento.Dal
        let YStart = Segmento.YDal
        let XEnd   = Segmento.Al
        let YEnd   = Segmento.YAl
        this.ObjGrafico.AddSegmento(XStart, YStart, XEnd, YEnd, Segmento.Label)
      }

      if(this.ObjGrafico.OtherAxis.length == 1)
      {
        for(let i = 0; i < this.ListaFalde.length; i++)
        {
          this.Grafici['Falda' + i] = this.ObjGrafico.AddGroupPoint(1, this.ColoriFalde[i], this.SpessoreGrafico, true, this.ObjGrafico.TerzoAsse, null, false)

          for(let j = 0; j < this.ListaFalde[i].Dati.length; j++)
          {
            let Dato   = this.ListaFalde[i].Dati[j]
            let XCoord = Date.parse(Dato.Data)
            this.Grafici['Falda' + i].AddPoint(XCoord, Dato.Pressione)
          }
        }
      }
    },

    DrawVelocita(Giornaliera, TipoSpostIncl)
    {
      var HandleCampione = function(LastOne)
      {
        if(CountCampioni != 0)
        {
          if(TipoSpostIncl)
            Velocita = SumCampioni / CountCampioni
          else
            Velocita = SumCampioni / CountCampioni;
          
          if(Giornaliera)
            Velocita = Velocita * 24;
          
          if(MaxValue < Velocita) 
            MaxValue = Velocita;

          if(MinValue > Velocita) 
            MinValue = Velocita;

          if(LastOne)
            if(!Giornaliera)
              // DataDaPlottare = Math.trunc(LastDate / MS_X_HOUR) * MS_X_HOUR;
              DataDaPlottare = LastDate.substr(0,13) + ':00'
            else
              // DataDaPlottare = Math.trunc(LastDate / MS_X_DAY) * MS_X_DAY + MS_X_DAY / 2
              DataDaPlottare = LastDate.substr(0,10) + ' 12:00'

          Result.push({X : Date.parse(DataDaPlottare), Y : Velocita})
          
          /*if(DataDaRegist - LastPosizione > 2 * 24 * 60 * 60 * 1000)
            MoveDone = false;
            LastPosizione = DataDaPlottare*/

          if (TipoSpostIncl)
          {
            if(CampioneSensore.Velocita != null)
            {
              SumCampioni   = CampioneSensore.Velocita;
              CountCampioni = 1;
            }
          }
          else
          {
            if(CampioneSensore.VelocitaProf != null)
            {
              SumCampioni   = CampioneSensore.VelocitaProf;
              CountCampioni = 1;
            }
          }
          LastDate      = DataCampione
        }
      }

      let Result        = [] 
      let IndexLista    = this.Modulo.Dati.length
      let CountCampioni = 0
      let SumCampioni   = 0
      let Velocita      = 0
      let MaxValue      = this.Modulo.MaxAdattamentoAsseYVel
      let MinValue      = this.Modulo.MinAdattamentoAsseYVel

      if(IndexLista != -1)
      {
        // Parte da 1 perchè il primo campione non ha la velocità
        if (this.Modulo.Dati.length > 1)
        {
          // var LastDate = Date.parse(this.Modulo.Dati[1].Data)
          var LastDate = this.Modulo.Dati[1].Data
          
          for (let i = 1; i < this.Modulo.Dati.length; i++)
          {
            var CampioneSensore   = this.Modulo.Dati[i];
            if (CampioneSensore.Pitch == null || CampioneSensore.Roll == null)
              continue
            // var DataDaPlottare    = 0;
            var DataDaPlottare = ''
            // var DataCampione      = Date.parse(CampioneSensore.Data)
            var DataCampione = CampioneSensore.Data

            if(!Giornaliera)
            {
              // if(Math.trunc(LastDate / MS_X_HOUR) != Math.trunc(DataCampione / MS_X_HOUR))
              //   DataDaPlottare = Math.trunc(LastDate / MS_X_HOUR) * MS_X_HOUR;
              if (DataCampione.substr(0,13) != LastDate.substr(0,13))
                DataDaPlottare = LastDate.substr(0,13) + ':00'
            }
            else
            {
              // if(Math.trunc(LastDate / MS_X_DAY) != Math.trunc(DataCampione / MS_X_DAY))
              //   DataDaPlottare = Math.trunc(LastDate / MS_X_DAY) * MS_X_DAY + MS_X_DAY / 2
              if (DataCampione.substr(0,10) != LastDate.substr(0,10))
                DataDaPlottare = LastDate.substr(0,10) + ' 12:00'
            }

            // if(DataDaPlottare != 0)
            if(DataDaPlottare != '')
              HandleCampione(false)
            else
            {
              if(TipoSpostIncl)
              {
                if(CampioneSensore.Velocita != null)
                {
                  SumCampioni = SumCampioni + CampioneSensore.Velocita;
                  CountCampioni++;
                }
              }
              else
              {
                if(CampioneSensore.VelocitaProf != null)
                {
                  SumCampioni = SumCampioni + CampioneSensore.VelocitaProf;
                  CountCampioni++;
                }
              }
            }
          }
          HandleCampione(true)
        }
      }

      // this.Modulo.MinAdattamentoAsseYVel = MinValue
      // this.Modulo.MaxAdattamentoAsseYVel = MaxValue
      // this.ObjGrafico.AxisY.Max = MinValue
      // this.ObjGrafico.AxisY.Min = MaxValue
      let UdmY = Math.abs(MaxValue - MinValue) / 10

      if(UdmY < 0.1)
        UdmY = TZMathFunct.GetMultiplo(UdmY, 0.01, 'Eccesso')
      else UdmY = TZMathFunct.GetMultiplo(UdmY, 0.1, 'Eccesso')

      this.Adatta(MaxValue, MinValue, UdmY)

      return Result
    },

    DrawAccelerazione(Giornaliera, TipoSpostIncl)
    {
      var HandleCampione = function(LastOne)
      {
        if(CountCampioni != 0)
        {
          if(TipoSpostIncl)
            Accelerazione = SumCampioni / CountCampioni
          else 
            Accelerazione = SumCampioni / CountCampioni;
          
          if(Giornaliera)
            Accelerazione = Accelerazione * 24;
          
          if(MaxValue < Accelerazione) 
            MaxValue = Accelerazione;

          if(MinValue > Accelerazione) 
            MinValue = Accelerazione;

          if(LastOne)
            if(!Giornaliera)
              // DataDaPlottare = Math.trunc(LastDate / MS_X_HOUR) * MS_X_HOUR;
              DataDaPlottare = LastDate.substr(0,13) + ':00'
            else 
              // DataDaPlottare = Math.trunc(LastDate / MS_X_DAY) * MS_X_DAY + MS_X_DAY / 2
              DataDaPlottare = LastDate.substr(0,10) + ' 12:00'

          Result.push({X : Date.parse(DataDaPlottare), Y : Accelerazione})
          /*if(DataDaRegist - LastPosizione > 2 * 24 * 60 * 60 * 1000)
            MoveDone = false;
            LastPosizione = DataDaPlottare*/

          if (TipoSpostIncl)
          {
            if(CampioneSensore.Accelerazione != null)
            {
              SumCampioni   = CampioneSensore.Accelerazione;
              CountCampioni = 1;
            }
          }
          else
          {
            if(CampioneSensore.AccelerazioneProf != null)
            {
              SumCampioni   = CampioneSensore.AccelerazioneProf;
              CountCampioni = 1;
            }
          }
          LastDate      = DataCampione
        }
      }

      let Result        = [] 
      let IndexLista    = this.Modulo.Dati.length
      let CountCampioni = 0
      let SumCampioni   = 0
      let Accelerazione = 0
      let MaxValue      = this.Modulo.MaxAdattamentoAsseYAccel
      let MinValue      = this.Modulo.MinAdattamentoAsseYAccel 

      if(IndexLista != -1)
      {
        // Parte da 2 perchè i primi due campioni non hanno l'accelerazione
        if (this.Modulo.Dati.length > 2)
        {
          // var LastDate = Date.parse(this.Modulo.Dati[2].Data)
          var LastDate = this.Modulo.Dati[2].Data
          
          for (let i = 2; i < this.Modulo.Dati.length; i++)
          {
            var CampioneSensore   = this.Modulo.Dati[i];
            if (CampioneSensore.Pitch == null || CampioneSensore.Roll == null)
              continue
            // var DataDaPlottare    = 0;
            var DataDaPlottare = ''
            // var DataCampione      = Date.parse(CampioneSensore.Data)
            var DataCampione = CampioneSensore.Data

            if(!Giornaliera)
            {
              // if(Math.trunc(LastDate / MS_X_HOUR) != Math.trunc(DataCampione / MS_X_HOUR))
              //   DataDaPlottare = Math.trunc(LastDate / MS_X_HOUR) * MS_X_HOUR;
              if (DataCampione.substr(0,13) != LastDate.substr(0,13))
                DataDaPlottare = LastDate.substr(0,13) + ':00'
            }
            else
            {
              // if(Math.trunc(LastDate / MS_X_DAY) != Math.trunc(DataCampione / MS_X_DAY))
              //   DataDaPlottare = Math.trunc(LastDate / MS_X_DAY) * MS_X_DAY + MS_X_DAY / 2
              if (DataCampione.substr(0,10) != LastDate.substr(0,10))
                DataDaPlottare = LastDate.substr(0,10) + ' 12:00'
            }

            // if(DataDaPlottare != 0)
            if(DataDaPlottare != '')
              HandleCampione(false)
            else
            {
              if(TipoSpostIncl)
              {
                if(CampioneSensore.Velocita != null)
                {
                  SumCampioni = SumCampioni + CampioneSensore.Accelerazione;
                  CountCampioni++;
                }
              }
              else
              {
                if(CampioneSensore.AccelerazioneProf != null)
                {
                  SumCampioni = SumCampioni + CampioneSensore.AccelerazioneProf;
                  CountCampioni++;
                }
              }
            }
          }
          HandleCampione(true)
        }
      }

      // this.Modulo.MinAdattamentoAsseYVel = MinValue
      // this.Modulo.MaxAdattamentoAsseYVel = MaxValue
      // this.ObjGrafico.AxisY.Max = MinValue
      // this.ObjGrafico.AxisY.Min = MaxValue
      let UdmY = Math.abs(MaxValue - MinValue) / 10

      if(UdmY < 0.1)
        UdmY = TZMathFunct.GetMultiplo(UdmY, 0.01, 'Eccesso')
      else UdmY = TZMathFunct.GetMultiplo(UdmY, 0.1, 'Eccesso')

      this.Adatta(MaxValue, MinValue, UdmY)

      return Result
    },

    GestisciListaFalde()
    {
      let MaxPress = -9_999
      let MinPress = 9_999

      for(let i = 0; i < this.ListaFalde.length; i++)
        for(let j = 0; j < this.ListaFalde[i].Dati.length; j++)
        {
          if(this.ListaFalde[i].Dati[j].Pressione != null)
          {
            if(MaxPress < this.ListaFalde[i].Dati[j].Pressione)
              MaxPress = this.ListaFalde[i].Dati[j].Pressione

            if(MinPress > this.ListaFalde[i].Dati[j].Pressione)
              MinPress = this.ListaFalde[i].Dati[j].Pressione
          }
        }

      if(MaxPress != 0 || MinPress != 0)
      {
        let SemiWidth                = (Math.abs(MaxPress - MinPress) * 0.08) / 2;
        let MinAdattamentoAsseYPress = TZMathFunct.GetMultiplo(MinPress - SemiWidth, 0.1, 'Difetto');
        let MaxAdattamentoAsseYPress = TZMathFunct.GetMultiplo(MaxPress + SemiWidth, 0.1, 'Eccesso');
        let UdmYPress                = Math.abs(MaxAdattamentoAsseYPress - MinAdattamentoAsseYPress) / 10

        // if(UdmYPress < 0.1)
        //   UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.01, 'Eccesso')
        // else UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.1, 'Eccesso')

        // if(UdmYPress < 0.01)
        //   UdmYPress = 0.01;

        UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.1, 'Eccesso')
        if (UdmYPress < 0.1)
          UdmYPress = 0.1
          
        if(this.OggettoTotaleSpostamento != null)
        {
          this.CurrentOggettoTotaleSpostamento.MinAdattamentoAsseYPress = MinAdattamentoAsseYPress;
          this.CurrentOggettoTotaleSpostamento.MaxAdattamentoAsseYPress = MaxAdattamentoAsseYPress;
          this.CurrentOggettoTotaleSpostamento.UdmYPress                = UdmYPress
        }
        else
        {
          this.CurrentModulo.MinAdattamentoAsseYPress = MinAdattamentoAsseYPress;
          this.CurrentModulo.MaxAdattamentoAsseYPress = MaxAdattamentoAsseYPress;
          this.CurrentModulo.UdmYPress                = UdmYPress
        }
      }
      else
      {
        if(this.OggettoTotaleSpostamento != null)
        {
          this.CurrentOggettoTotaleSpostamento.MinAdattamentoAsseYPress =  0.2 
          this.CurrentOggettoTotaleSpostamento.MaxAdattamentoAsseYPress = -0.2
          this.CurrentOggettoTotaleSpostamento.UdmYPress                =  0.1
        }
        else
        { 
          this.CurrentModulo.MinAdattamentoAsseYPress =  0.2 
          this.CurrentModulo.MaxAdattamentoAsseYPress = -0.2
          this.CurrentModulo.UdmYPress                =  0.1 
        }
      }
    },

    DoRepaint()
    {
      this.ObjGrafico.ClearListaRighelli()
      for (let i = 0; i < this.PropsGrafico.ListaRighelli.length; i++)
      {
        let Righello                = this.PropsGrafico.ListaRighelli[i]
        let AsseRighello            = this.ObjGrafico.AddRighello()
        AsseRighello.Color          = Righello.Colore
        AsseRighello.ParalleloAsseX = false
        AsseRighello.DistanceFromY  = Date.parse(Righello.DateTime)
      }
      // if(this.PropsGrafico.SoglieDiAllarme)
      // {
      //   for(let i = 0; i < SOGLIE_GRAFICI_VELOCITA.length; i++)
      //   {
      //     let AsseRighello           = this.ObjGrafico.AddOtherAxis()
      //     AsseRighello.Inclination   = 0
      //     AsseRighello.DistanceFromX = SOGLIE_GRAFICI_VELOCITA[i]
      //     AsseRighello.Color         = "red"
      //     // AsseRighello.Min           = this.PropsGrafico.AxisX.Min
      //     // AsseRighello.Max           = this.PropsGrafico.AxisX.Max
      //   }
      // }
      if (this.PropsGrafico.AxisX.Modificato)
      {
        let NewUdm = 0
        switch (this.PropsGrafico.AxisX.TipoUdmX)
        {
          case TIPI_UDM_X.Giorni  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 86400000
                                      break
                                    }
          case TIPI_UDM_X.Ore     : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 3600000
                                      break
                                    }
          case TIPI_UDM_X.Minuti  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 60000
                                      break
                                    }
          default                 : NewUdm = this.PropsGrafico.AxisX.UdmX
        }
        this.ObjGrafico.AxisX.OffsetNotch = 0
        this.ObjGrafico.AxisX.NotchDim    = NewUdm
      }

      if(this.PropsGrafico.AxisY.Modificato)
      {
        this.ObjGrafico.AxisY.Max         = this.PropsGrafico.AxisY.Max
        this.ObjGrafico.AxisY.Min         = this.PropsGrafico.AxisY.Min
        this.ObjGrafico.AxisY.NotchDim    = this.PropsGrafico.AxisY.Udm
        this.ObjGrafico.AxisY.OffsetNotch = 0
        // this.PropsGrafico.AxisY.Modificato = false
        this.ObjGrafico.AxisY.LabelType   = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
      }
      
      setTimeout(() => { this.ObjGrafico.Paint()})
    },

    AggiungiLineeAllarmi() 
    {
      var Soglie = [
                     { Value: this.SoglieAllarmi.Blu,     Colore: this.ColoriSoglieAllarmi.Blu },
                     { Value: this.SoglieAllarmi.Giallo,  Colore: this.ColoriSoglieAllarmi.Giallo },
                     { Value: this.SoglieAllarmi.Arancio, Colore: this.ColoriSoglieAllarmi.Arancio },
                     { Value: this.SoglieAllarmi.Rosso,   Colore: this.ColoriSoglieAllarmi.Rosso }
                  ];

      Soglie.forEach(Livello => {
                                  if (Livello.Value != null) 
                                  {
                                    var YValues = [Livello.Value, - Livello.Value];
                                    YValues.forEach(CoordY => {
                                                                if (CoordY >= this.ObjGrafico.AxisY.Min && CoordY <= this.ObjGrafico.AxisY.Max)
                                                                {
                                                                  this.ObjGrafico.AddSegmento(
                                                                                              this.ObjGrafico.AxisX.Min, 
                                                                                              CoordY,
                                                                                              this.ObjGrafico.AxisX.Max, 
                                                                                              CoordY,
                                                                                              ''
                                                                                            );
                                                                  var Segmento = this.ObjGrafico.ListaSegmenti[this.ObjGrafico.ListaSegmenti.length - 1];
                                                                  Segmento.Color = Livello.Colore;
                                                                  Segmento.PenWidth = this.SpessoreLineeAllarmi.Spessore;
                                                                  Segmento.PenStyle = [];
                                                                }
                                                              }
                                    )
                                  }
                                });
    },

    RedrawAllarmi(Active)
    {  
      this.ObjGrafico.ClearSegmenti();
      if (Active && this.SoglieAllarmi) 
      {
        this.AggiungiLineeAllarmi();
      }
      this.ObjGrafico.Paint();
    }
   },

  computed:
  {
    CurrentListaFalde : 
    {
      get()
      {
        return this.ListaFalde
      }
    },

    LsSegmenti : 
    {
      get()
      {
        return this.ListaSegmenti
      }
    },

    CurrentModulo :
    {
      get()
      {
        return this.Modulo
      }
    },

    CurrentOggettoTotaleSpostamento :
    {
      get()
      {
        return this.OggettoTotaleSpostamento
      }
    },    

    GraphData:
    {
      get()
      {
        return this.PropsGrafico
      }
    },
    
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    },

    AbilitaDisegnaAllarmi:
    {
      get()
      {
        return this.PropsGrafico.CbSoglieAllarmi;
      }
    }
  },

  watch:
  {
    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          let ArrayOggettoGrafico = TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico)
          if(ArrayOggettoGrafico.OtherAxis != undefined && ArrayOggettoGrafico.OtherAxis.length > 0)
          {
            ArrayOggettoGrafico.OtherAxis.forEach(AsseAlternativa => { AsseAlternativa.NotchFontSize = 17 });
          }
          this.InfoCatena.DatiPDF.push(this.MixInsGetDatiPerPDF(true, this.Modulo, ArrayOggettoGrafico))
        }
      }
    },

    Repaint:
    {
      handler()
      {
        this.DoRepaint()
        setTimeout(() => {
          this.RedrawAllarmi(true)
        }, 50);
      }
    },

    ListaFaldeChange:
    {
      handler()
      {
        if(this.ListaFalde != undefined && this.ListaFalde.length != 0)
          this.GestisciListaFalde()
        else
        {
          this.ObjGrafico.ClearOtherAxes()
          this.ObjGrafico.TerzoAsse = null
        }
        this.Disegna()
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.Disegna()
      }
    },

    AbilitaDisegnaVelocita:
    {
      handler(NewValue)
      {
        if(!NewValue)
        {
          if(this.IndiceSegmento % 2 !== 0)
          {
            this.IndiceSegmento--
            this.LsSegmenti.pop()
            window.removeEventListener('mousemove', this.GetMousePosition)
            this.DisegnoInCorso = false
            this.Disegna()
          }
          this.SegmentoVelocita = {}
        }
      }
    },

    PressAdatta:
    {
      handler()
      {
        this.Disegna()
      }
    },

    AbilitaDisegnaAllarmi: 
    {
      handler(NewValue) 
      {
        this.RedrawAllarmi(NewValue);
      }
    },

    SoglieAllarmi:
    {
      deep: true,
      handler()
      {
        if(this.PropsGrafico.CbSoglieAllarmi)
        {
          this.RedrawAllarmi(true);
        }
      }
    }
  },

  mounted()
  {
    if(this.OggettoDati != null)
    {
      this.ObjDati = this.OggettoDati
      this.ObjDati.TipoGrafico = this.TipoGrafico
    }

    this.ObjGrafico  = new TZGraphLine(this.$refs.Canvas)
    this.GraphData.OggettoGrafico = this.ObjGrafico
    // this.ObjGrafico  = new TZGraph(this.$refs.Canvas) 

    this.ObjGrafico.VerticalLabelAxisX  = true
    this.ObjGrafico.DrawMarkup          = false
    this.ObjGrafico.AxisY.CenterLabel   = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
    if(this.ObjGrafico.AxisY.NotchDim != undefined)
      this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime

    if(this.IsVelocita || this.IsVelocitaGiornaliera)
    {
      this.ObjGrafico.VerticalLabelAxisX   = true
      this.ObjGrafico.DrawMarkup           = false
      if(this.IsVelocita)
        this.ObjGrafico.AxisY.CenterLabel  = this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_VEL_H',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_H',this.LinguaUtente) + ']'
      if(this.IsVelocitaGiornaliera)
        this.ObjGrafico.AxisY.CenterLabel  = this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_VEL_GG',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']'
      this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
      this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
      this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi
      if(this.ObjGrafico.AxisY.NotchDim != undefined)
        this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
      this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime
    }
    else
    {
      if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
      {
        this.ObjGrafico.VerticalLabelAxisX  = true
        this.ObjGrafico.DrawMarkup          = false
        if(this.IsAccelerazione)
          this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_ACC_H',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_2H',this.LinguaUtente) + ']'
        if(this.IsAccelerazioneGiornaliera)
          this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_ACC_GG',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_2GG',this.LinguaUtente) + ']'
          this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.AxisY.NotchDim != undefined)
          this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
        this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      }
      else
      {
        this.ObjGrafico.VerticalLabelAxisX   = true
        this.ObjGrafico.DrawMarkup           = false
        this.ObjGrafico.AxisY.CenterLabel    = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
        this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.AxisY.NotchDim != undefined)
          this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
        this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime

        //Prova Asse multiplo
        // this.ObjGrafico.MultipleDrawingAxis = true
        // for(let i = 0; i < 3; i++)
        // {
        //   let OggettoGrafico                   = this.ObjGrafico.AddOtherAxis()
        //   OggettoGrafico.AddLabel(' Gino pino [°C] - ' + i )
        //   OggettoGrafico.NotchType  = TZGraphNotchType.notStandard
        //   OggettoGrafico.LabelType  = TZGraphLabelType.lblDecimi
        // }
      }
    }
    this.ObjGrafico.AxisX.NotchPenWidth  = 1
    this.ObjGrafico.AxisY.NotchPenWidth  = 1
    this.ObjGrafico.AxisX.NotchColor     = 'grey'
    this.ObjGrafico.AxisY.NotchColor     = 'grey'
    this.ObjGrafico.AxisX.FontSize       = 13
    this.ObjGrafico.AxisY.FontSize       = 13
    this.ObjGrafico.AxisX.NotchFontSize  = 13
    this.ObjGrafico.AxisY.NotchFontSize  = 13
    this.ObjGrafico.__Margins.MinBottom += 40
    this.ObjGrafico.__Margins.MinLeft   += 30

    this.Disegna()
    // setTimeout(() => { this.PaintCanvas() }, 1)

    if (this.PropsGrafico.CbSoglieAllarmi)
    {
      if(this.OggettoTotaleSpostamento)
        setTimeout(() => { this.RedrawAllarmi(true) }, 500)
      else this.RedrawAllarmi(true)
    }
  },
  
  unmounted()
  {
    window.removeEventListener('mousemove', this.GetMousePosition)
  }

}
</script>